export default "__VITE_ASSET__voWx_AdQ__"